import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative h-[520px] md:h-[620px] flex items-center justify-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Artistic%20Korean%20manhwa%20style%20illustration%20with%20warm%20coral%20and%20amber%20tones%2C%20abstract%20flowing%20ink%20brush%20strokes%20blending%20with%20modern%20digital%20art%2C%20soft%20gradient%20background%20with%20subtle%20texture%2C%20elegant%20atmospheric%20composition%2C%20no%20text%2C%20warm%20aesthetic%2C%20minimalist%20yet%20dynamic%20feel&width=1600&height=900&seq=hero-bg-manhwa&orientation=landscape"
        alt="尾巴漫画 - 韩国漫画在线阅读"
        className="absolute inset-0 w-full h-full object-cover"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/30 to-black/60"></div>

      <div className="relative z-10 text-center px-4 w-full max-w-4xl mx-auto">
        <p className="text-sm md:text-base text-background-50/80 mb-3 tracking-wider font-medium animate-fade-in">
          无删减韩国漫画 · 下拉式免费阅读
        </p>
        <h1 className="text-3xl md:text-5xl lg:text-6xl font-bold font-heading text-background-50 mb-4 leading-tight animate-fade-in">
          尾巴漫画
        </h1>
        <p className="text-sm md:text-lg text-background-50/70 max-w-2xl mx-auto mb-8 leading-relaxed animate-fade-in">
          汇聚精选韩国漫画，热门韩漫实时跟进。<br className="hidden sm:block" />
          无删减、全免费、下拉式阅读，带给您极致的漫画阅读体验。
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-3 animate-fade-in">
          <Link
            to="/category/all"
            className="w-full sm:w-auto px-8 py-3 rounded-full bg-primary-500 text-background-50 font-semibold text-sm hover:bg-primary-600 transition-all duration-300 whitespace-nowrap"
          >
            开始阅读
          </Link>
          <Link
            to="/about"
            className="w-full sm:w-auto px-8 py-3 rounded-full bg-background-50/15 text-background-50 font-medium text-sm hover:bg-background-50/25 backdrop-blur-sm transition-all duration-300 whitespace-nowrap border border-background-50/20"
          >
            了解更多
          </Link>
        </div>

        <div className="flex items-center justify-center gap-8 mt-10 text-background-50/60 animate-fade-in">
          <div className="text-center">
            <p className="text-2xl md:text-3xl font-bold font-heading text-background-50">24+</p>
            <p className="text-xs mt-1">精选漫画</p>
          </div>
          <div className="w-px h-8 bg-background-50/20"></div>
          <div className="text-center">
            <p className="text-2xl md:text-3xl font-bold font-heading text-background-50">8</p>
            <p className="text-xs mt-1">分类类型</p>
          </div>
          <div className="w-px h-8 bg-background-50/20"></div>
          <div className="text-center">
            <p className="text-2xl md:text-3xl font-bold font-heading text-background-50">100+</p>
            <p className="text-xs mt-1">连载章节</p>
          </div>
        </div>
      </div>
    </section>
  );
}